import { Injectable } from '@angular/core';
import {empty} from '../../functions';

@Injectable({
  providedIn: 'root'
})
export class ValidationService {


  constructor() { }

  /**
   * Perform a regex validation on a value
   *
   * @param regex
   * @param value
   * @return boolean
   */
  regexValidation(regex: any, value: any) {

    let regexPattern = null;

    switch (regex) {

      case '':
        if (value === '') return true;
        else return false;

      case true:
        if (value === true) return true;
        else return false;

      case 'required':
        if (empty(value))  return false;
        else return true;

      case 'number':
        regexPattern = /^\d+$/;
        break;

      case 'email':
        regexPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        break;

      case 'url':
        regexPattern = /^(ftp|http|https):\/\/[^ "]+$/;
        break;

      default:
        regexPattern = regex;
        break;

    }

    const Regex = new RegExp(regexPattern);

    if (Regex.test(value) === true) {
      return true;
    } else {
      return false;
    }

  }

  goToModalError() {
    const elModalSearch = 'modal';
    const modalElements = document.getElementsByClassName(elModalSearch);
    if (modalElements[0] !== undefined) {

      setTimeout( () => {

        const errorElName = '.validation-error';
        const errorElements = document.querySelectorAll<HTMLElement>(errorElName);
        if (errorElements[0] !== undefined) {
          modalElements[0].scrollTo({
            top: errorElements[0].offsetTop,
            behavior: 'smooth'
          });
        }

      }, 200);
    }
  }

}
